<nav class="navbar" *ngIf="!showSearchbar">
    <div class="mobile-navbar-left app-appnavbar-left-section">
        <ul class="nav navbar-nav navbar-left">
            <li *ngIf="leftNavPanel" >
                <a (click)="leftNavPanel.toggle();" role="button" href="javascript: void(0);" aria-label="Menu">
                    <i [ngClass]="leftnavpaneliconclass"></i>
                    </a>
                </li>
            <li *ngIf="backbutton">
                <a class="btn-back" type="button" role="button" aria-label="Back">
                    <i [ngClass]="backbuttoniconclass"></i><span [innerText]="backbuttonlabel"></span>
                </a>
            </li>
        </ul>
    </div>
    <div class="mobile-navbar-center app-appnavbar-middle-section">
        <div class="navbar-header">
            <h1 class="navbar-brand">
                <img data-identifier="img" class="brand-image" [alt]="title" width="32" height="32" *ngIf="imgsrc" [src]="imgsrc | image"/>
                <span class="title" [innerText]="title || ''"></span>
            </h1>
        </div>
    </div>
    <div class="mobile-navbar-right app-appnavbar-right-section">
        <ul class="nav navbar-nav navbar-right">
            <li wmsTransclude>
                <ng-content></ng-content>
            </li>
            <li *ngIf="searchbutton">
                <a class="btn-search btn-transparent" type="button" (click)="showSearchbar = true" href="javascript: void(0);" aria-label="Search">
                    <i [ngClass]="searchbuttoniconclass"></i><span [innerText]="searchbuttonlabel"></span>
                </a>
            </li>
        </ul>
    </div>
</nav>
<nav class="navbar searchbar" [hidden]="!showSearchbar">
    <div class="mobile-navbar-left">
        <ul class="nav navbar-nav navbar-left">
            <li>
                <a class="btn-back" type="button" role="button" aria-label="Back">
                    <i [ngClass]="backbuttoniconclass"></i>
                </a>
            </li>
        </ul>
    </div>
    <div class="mobile-navbar-center search-container">
        <div wmSearch>
        </div>
    </div>
    <div class="mobile-navbar-right">
        <ul class="nav navbar-nav navbar-right">
            <li>
                <a class="btn-cancel btn-transparent" type="button" (click)="showSearchbar = false;"  href="javascript: void(0);" role="button" aria-label="Cancel"> Cancel </a>
            </li>
        </ul>
    </div>
</nav>
